import {
  AlertMessage,
  ComponentType,
  ContentLoader,
  IContentLoaderParagraphConfig,
  IReactBaseProps,
} from '@gcl/react-core';
import * as React from 'react';
import './DisplayWrapper.scss';

export interface IDisplayWrapperProps extends IReactBaseProps {
  isLoading: boolean;
  error?: string;
  Loader?: React.ReactElement;
  ErrorDisplay?: React.ReactElement;
  shouldDisplayErrorWithChildren?: boolean;
  loaderProps?: IContentLoaderParagraphConfig[];
}

export const DisplayWrapper: React.FC<IDisplayWrapperProps> = ({
  isLoading,
  shouldDisplayErrorWithChildren = false,
  error,
  ErrorDisplay = undefined,
  Loader = undefined,
  children,
  loaderProps,
}) => {
  const DefaultLoader = (
    <ContentLoader
      active={isLoading}
      linePadding={10}
      lineHeight={10}
      paragraphConfigs={loaderProps ?? [{ suffixBlankRow: false, numberOfRows: 1, lineHeight: 30 }]}
    >
      {children}
    </ContentLoader>
  );
  const [LocalLoader, setLocalLoader] = React.useState(Loader || DefaultLoader);

  const DefaultErrorDisplay = <AlertMessage content={error} type={ComponentType.Danger} />;
  const [LocalErrorDisplay, setLocalErrorDisplay] = React.useState(ErrorDisplay || DefaultErrorDisplay);

  let DisplayComponent = null;
  if (isLoading) DisplayComponent = LocalLoader;
  else if (!isLoading && error && !shouldDisplayErrorWithChildren) DisplayComponent = LocalErrorDisplay;
  else if (!isLoading && error && shouldDisplayErrorWithChildren)
    DisplayComponent = (
      <>
        {children}
        {LocalErrorDisplay}
      </>
    );
  else DisplayComponent = children;

  return <div className="gcl-gems-display-wrapper-container">{DisplayComponent}</div>;
};
